import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/auth';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { CambioClave } from './recuperacionInfo/cambiarComtraseña';

function Header(props) {

    moment.locale('es'); 

    const { user, logout } = useContext(AuthContext);
    const [fechaSistema, setFechaSistema] = useState(JSON.parse(localStorage.getItem('fechasistema')));
    const [usuario, setUsuario] = useState(JSON.parse(localStorage.getItem('login')));
    const [cambiarClave , setCambiarClave] = useState(false)

    let el;
    function menuclick() {
        props.onCambiar('inicio')
        if (el = document.getElementById("wrapper")) {
            el.classList.toggle("toggled");
        }
    }

    const modalCambiarClave =()=>{
        if(!cambiarClave){
            setCambiarClave(true)
        } else {
            setCambiarClave(false)
        }
    }
    const renderPass = () => {
        setCambiarClave(false)
    }

    const header = (user && (
        <nav className="col-md-12 navbar navbar-expand-lg navbar-light azulGradiant py-2 px-2 d-flex justify-content-between" id='one'>
            
            <div className="mx-2 d-none d-xl-block">
                <i className="fas fa-align-left  text-light fs-4" onClick={menuclick} id="menu-toggle" />
            </div>

            <div className="col-1  d-block d-xl-none">
                <i className="fas fa-align-left  text-light fs-4" onClick={menuclick} id="menu-toggle" />
            </div>
            
            <div className='col d-none d-xl-block m-0 px-0'>
                <label className='titulo-header'>INICIO</label>
            </div>

            <div className='col-4 d-flex justify-content-end '>
                <label className='text-light fw-bold d-none d-xl-block'><i className="fas fa-calendar-alt me-2" />{moment(fechaSistema).format('L')}</label >
                <div className="dropdown ">
                    <a className=" dropdown-toggle text-light fw-bold mx-4" type="button" id="dropdownMenuButton" data-mdb-toggle="dropdown" aria-expanded="false" >
                    <i className="fas fa-user me-2" />{usuario}
                    </a>
                    <ul className="dropdown-menu sombras " aria-labelledby="dropdownMenuButton">
                        <li onClick={modalCambiarClave}>
                            <Link

                                to="#"
                                className="dropdown-item ripple bg-light">
                                <span><i className="fas fa-key fa-fw me-1" />Cambiar Clave</span>
                            </Link>
                        </li>
                    
                    </ul>
                    </div> 
            </div>

            <div className='d-flex justify-content-center d-block d-xl-none '>
                <label className='text-light fw-bold'><i className="fas fa-calendar-alt me-2" />{moment(fechaSistema).format('L')}</label >
                {/* <label className='text-light fw-bold mx-4 '>   <i className="fas fa-user me-2" />{usuario}</label > */}
                <div className="dropdown ">
                    <a className=" dropdown-toggle text-light fw-bold mx-4" type="button" id="dropdownMenuButton" data-mdb-toggle="dropdown" aria-expanded="false" >
                    <i className="fas fa-user me-2" />{usuario}
                    </a>
                    <ul className="dropdown-menu sombras " aria-labelledby="dropdownMenuButton">
                        <li onClick={modalCambiarClave}>
                            <Link

                                to="#"
                                className="dropdown-item ripple bg-light">
                                <span><i className="fas fa-key fa-fw me-1" />Cambiar Clave</span>
                            </Link>
                        </li>
                    
                    </ul>
                    </div> 
               
            </div>

            <CambioClave 
            show={cambiarClave}
            onHideCancelar={modalCambiarClave}
            render={renderPass} />



        </nav>
    )

    )

    return header;

}

export default Header


// WEBPACK FOOTER //
// ./src/components/Header.js